<ion-row class="ion-justify-content-center">
  @if (large) {
    <ion-col class="ion-no-padding" size-xs="12" size-sm="9" size-md="8" size-lg="8" size-xl="8">
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </ion-col>
  }
  @if (!large) {
    <ion-col class="ion-no-padding" size-xs="12" size-sm="8" size-md="7" size-lg="4" size-xl="3">
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </ion-col>
  }

  <ng-template #content>
    <ng-content></ng-content>
  </ng-template>
</ion-row>
